import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | PackLog` : "PackLog | Did anyone feed the cat?";
    if (description) {
      const m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}
